import { EGender } from '@constants';
import { Select } from 'antd';
import { useTranslation } from 'react-i18next';

interface GenderSelectorProps {
  value?: EGender;
  onChange?: (value: EGender) => void;
  placeholder?: string;
  disabled?: boolean;
}

export const GenderSelector: React.FC<GenderSelectorProps> = ({
  value,
  onChange,
  placeholder,
  disabled = false
}) => {
  const { t } = useTranslation('DefaultTranslations');

  const options = [
    { value: EGender.MALE, label: t(EGender.MALE) },
    { value: EGender.FEMALE, label: t(EGender.FEMALE) }
  ];

  return (
    <Select
      value={value}
      onChange={onChange}
      options={options}
      placeholder={placeholder || t('SELECT_GENDER')}
      disabled={disabled}
      style={{ width: '100%' }}
    />
  );
};
